import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type NavigationState = {
    hardRedirectInProgress: boolean;

    // routeReloadKey is necessary to get angular2react components to re-render
    // see useAngularToReactRoute
    routeReloadKey: number;
};

const initialState: NavigationState = {
    hardRedirectInProgress: false,
    routeReloadKey: 0,
};

const navigationSliceInternal = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        startHardRedirect(state) {
            state.hardRedirectInProgress = true;
        },
        finishHardRedirect(state) {
            state.hardRedirectInProgress = false;
        },
        setRouteReloadKey(state, action: PayloadAction<number>) {
            state.routeReloadKey = action.payload;
        },
    },
});

export const navigationSlice = navigationSliceInternal;
export const navigationActions = navigationSliceInternal.actions;

export const selectNavigation = (state: { navigation?: NavigationState }) => state.navigation ?? initialState;
export const selectHardRedirectInProgress = (state: { navigation?: NavigationState }) =>
    selectNavigation(state).hardRedirectInProgress;
export const selectRouteReloadKey = (state: { navigation?: NavigationState }) => selectNavigation(state).routeReloadKey;
